<script setup lang="ts">
/**
 * Skeleton loader for ProductCard
 * Matches the exact layout of ProductCard.vue for smooth loading transitions
 */
</script>

<template>
  <div class="product-card-skeleton">
    <div class="skeleton-image">
      <div class="skeleton-shimmer"></div>
    </div>
    <div class="skeleton-content">
      <div class="skeleton-header">
        <div class="skeleton-title skeleton-shimmer"></div>
        <div class="skeleton-price skeleton-shimmer"></div>
      </div>
      <div class="skeleton-desc">
        <div class="skeleton-line skeleton-shimmer"></div>
        <div class="skeleton-line skeleton-shimmer short"></div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.product-card-skeleton {
  background: white;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.04);
  border: 1px solid rgba(0, 0, 0, 0.04);
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 360px;
}

.skeleton-image {
  position: relative;
  aspect-ratio: 4/3;
  background: #f1f5f9;
  overflow: hidden;
}

.skeleton-content {
  padding: 1.25rem;
  display: flex;
  flex-direction: column;
  flex: 1;
}

.skeleton-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 0.75rem;
  margin-bottom: 0.5rem;
}

.skeleton-title {
  height: 1.3rem;
  width: 65%;
  border-radius: 6px;
  background: #e2e8f0;
}

.skeleton-price {
  height: 1.3rem;
  width: 25%;
  border-radius: 6px;
  background: #e2e8f0;
}

.skeleton-desc {
  margin-top: 0.5rem;
  flex: 1;
}

.skeleton-line {
  height: 0.9rem;
  border-radius: 4px;
  background: #e2e8f0;
  margin-bottom: 0.5rem;
  width: 100%;
}

.skeleton-line.short {
  width: 70%;
}

/* Shimmer animation */
.skeleton-shimmer {
  position: relative;
}

.skeleton-shimmer::after {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.6) 50%,
    rgba(255, 255, 255, 0) 100%
  );
  animation: shimmer 1.8s infinite;
}

@keyframes shimmer {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
}

/* Respect reduced motion */
@media (prefers-reduced-motion: reduce) {
  .skeleton-shimmer::after {
    animation: none;
  }
}
</style>
